import { Subscription } from '../models/subscription/subscription.model';

export namespace Subscriptions {
  export class GetSubscriptions {
    static readonly type = '[Subscription api] GetSubscriptions';

    constructor(public force: boolean = false) {
    }
  }

  export class GetSubscription {
    static readonly type = '[Subscriptions api] GetSubscription';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class CreateSubscription {
    static readonly type = '[Subscriptions api] CreateSubscription';

    constructor(public subscription: Subscription) {
    }
  }

  export class UpdateSubscription {
    static readonly type = '[Subscriptions api] Update Subscription';

    constructor(public subscription: Subscription) {
    }
  }

  export class DeleteSubscription {
    static readonly type = '[Subscriptions api] Delete Subscription';

    constructor(public subscription: Subscription) {
    }
  }

  export class GetJobSubscription {
    static readonly type = '[Subscriptions api] GetJobSubscription';

    constructor(public id: string, public force: boolean = false) {
    }
  }
}
